import Vue from "vue";

export const tokenKey = process.env.TOKEN_KEY;

export const refreshTokenKey = process.env.REFRESH_TOKEN_KEY;

function isIPAddress(input) {
  const ipAddressRegex = /^([0-9]{1,3}\.){3}[0-9]{1,3}$/;
  return ipAddressRegex.test(input);
}

function getPrimaryDomain() {
  const hostname = window.location.hostname;
  if (hostname.indexOf("localhost") !== -1 || isIPAddress(hostname)) {
    return hostname;
  }

  const parts = hostname.split(".");
  const newParts = [];

  let stop = false;
  for (const part of parts) {
    if (!stop && part.startsWith("renogy")) {
      stop = true;
      newParts.push("");
      newParts.push(part);
    } else if (stop) {
      newParts.push(part);
    }
  }

  return newParts.join(".");
}

export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  Vue.cookie.set(name, content, {
    path: "/",
    domain: getPrimaryDomain(),
    expires: "1Y",
    samesite: "Strict",
  });
};

export const getStore = (name) => {
  if (!name) return;
  return Vue.cookie.get(name);
};

export const removeStore = (name) => {
  if (!name) return;
  const primaryDomain = getPrimaryDomain();
  if (primaryDomain === "localhost") {
    Vue.cookie.delete(name);
  } else {
    Vue.cookie.delete(name, {
      path: "/",
      domain: primaryDomain,
      samesite: "Strict",
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/storage.js